import axios from "axios";
import { getApiUrl } from "../utils/site";

const USER_API_URL = getApiUrl("/api/users");

export const parseGoogleCredential = (credential) => {
  if (!credential) {
    throw new Error("Google sign in returned no credential.");
  }

  try {
    const base64Url = credential.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
          .join("")
      )
    );
  } catch (error) {
    throw new Error("Unable to read Google profile.");
  }
};

export const registerUser = async (userData) => {
  const payload = {
    email: userData.email,
    full_name: userData.full_name,
    phone: userData.phone_number || userData.phone,
    password: userData.password,
  };

  const response = await axios.post(`${USER_API_URL}/sign`, payload);
  return response.data;
};

export const loginUser = async (email, password) => {
  const response = await axios.post(`${USER_API_URL}/login`, { email, password });
  return response.data;
};

export const googleSignIn = async (credential) => {
  const profile = parseGoogleCredential(credential);

  if (!profile?.sub || !profile?.email) {
    throw new Error("Unable to read Google profile.");
  }

  const response = await axios.post(`${USER_API_URL}/google-signin`, {
    google_id: profile.sub,
    email: profile.email,
    full_name: profile.name || "",
    avatar_url: profile.picture || "",
  });

  return response.data;
};
